export default "__VITE_ASSET__DdQC8flS__"